import { render, staticRenderFns } from "./markdown-field-widgets.vue?vue&type=template&id=7d020f91&"
import script from "./markdown-field-widgets.vue?vue&type=script&lang=js&"
export * from "./markdown-field-widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d020f91')) {
      api.createRecord('7d020f91', component.options)
    } else {
      api.reload('7d020f91', component.options)
    }
    module.hot.accept("./markdown-field-widgets.vue?vue&type=template&id=7d020f91&", function () {
      api.rerender('7d020f91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/markdown-field-widgets/markdown-field-widgets.vue"
export default component.exports